import {PaginatedBaseResponse, Response} from './api';

export type ReviewStatus = 'PUBLISHED';

export type Review = {
  commentId: number;
  appRating: number;
  commentStatus: ReviewStatus;
  firstName: string;
  commentDate: string;
  commentText: string;
  likeCounter: number;
  dislikeCounter: number;
  userRating: string;
  updatedAt: string;
  userVerCode: number;
  devResponseDate: string | undefined;
  devResponse: string | undefined;
};

export type ReviewSortType =
  | 'NEW_FIRST'
  | 'USEFUL_FIRST'
  | 'POSITIVE_FIRST'
  | 'NEGATIVE_FIRST';

export const defaultReviewSortType: ReviewSortType = 'NEW_FIRST';

// if more types added, pls add to next.config.js in rewrites
export const reviewSortTypeToPathParam: Record<ReviewSortType, string> = {
  NEW_FIRST: 'new',
  USEFUL_FIRST: 'useful',
  POSITIVE_FIRST: 'positive',
  NEGATIVE_FIRST: 'negative',
};

export const pathParamToReviewSortType = Object.entries(
  reviewSortTypeToPathParam,
).reduce(
  (accum, [key, value]) => {
    accum[value] = key as ReviewSortType;

    return accum;
  },
  {} as Record<string, ReviewSortType>,
);

type PaginatedResponse<T> = Response<
  {
    content: Array<T>;
    sortBy: ReviewSortType;
  } & PaginatedBaseResponse
>;

export type ReviewsResponse = PaginatedResponse<Review>;

export type ReviewsPageOptions = {
  packageName: string;
  page: number;
  sortType: ReviewSortType;
};

export type FeedbackSummary = {
  id: number;
  timestamp: string;
  published: boolean;
  positive: Array<string>;
  negative: Array<string>;
};
